// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string, number, nullOrUndefined, boolean } from "@altostra/type-validations/lib/primitives";

export const isAppsCatalogsCatalogIdFilteredSetsResult = objectOf({
  description: anyOf(nullOrUndefined, string),
  fields: arrayOf(
    objectOf({
      name: string,
      token: string,
      type: string,
    })
  ),
  name: string,
  source: string,
  num_items: number,
  storage_size: number,
  updated_at: anyOf(nullOrUndefined, string),
  created_at: anyOf(nullOrUndefined, string),
  filtered_sets: arrayOf(
    objectOf({
      id: string,
      name: string,
      description: string,
      created_at: nullOrUndefined,
      updated_at: nullOrUndefined,
      filters: arrayOf(
        objectOf({
          field: string,
          operator: string,
          value: anyOf(string, arrayOf(string)),
          type: string,
        })
      ),
      sort_field: anyOf(nullOrUndefined, number),
      sort_order: anyOf(nullOrUndefined, boolean),
      processing: boolean,
      results_limit: number,
      size: number,
      source: string,
    })
  ),
  id: string,
  import_errors: arrayOf(nullOrUndefined),
  processing: boolean,
  update_error: objectOf({}),
  back_in_stock_enabled: boolean,
  price_drop_enabled: boolean,
  price_drop_operator: nullOrUndefined,
  price_drop_unit: nullOrUndefined,
  price_drop_value: nullOrUndefined,
  product_blocks_enabled: boolean,
  notification_rate: nullOrUndefined,
  notification_period_rate: nullOrUndefined,
});
